import React from 'react'

const ErrorMesage = props => (
  <div className="text-danger">{props.children}</div>
);

export default ErrorMesage
